import { render, staticRenderFns } from "./CardScaffoldContractorsManagerView.vue?vue&type=template&id=4a491c31"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a491c31')) {
      api.createRecord('4a491c31', component.options)
    } else {
      api.reload('4a491c31', component.options)
    }
    module.hot.accept("./CardScaffoldContractorsManagerView.vue?vue&type=template&id=4a491c31", function () {
      api.rerender('4a491c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardScaffoldContractorsManagerView.vue"
export default component.exports